import React from 'react';

import { OfferDto } from 'api/OffersApi';

import styles from './OfferRowLabel.module.scss';

export interface TableRowLabelProps {
  offer: OfferDto;
}

const OfferRowLabel = ({ offer }: TableRowLabelProps) => {
  let text = null;

  if (offer.isLowestPayment) {
    text = 'Lowest Payment';
  } else if (offer.isLowestRate) {
    text = 'Lowest Rate';
  }

  if (text) {
    return (
      <div className={styles.tableRowLabel}>
        <div className={styles.tableRowLabelLeftElement}></div>
        <div className={styles.tableRowLabelRightElement}></div>
        {text}
      </div>
    );
  }

  return null;
};

export default OfferRowLabel;
